import { AppBundle } from 'src/api/optimalprint-sdk.d';

type ProductItem = AppBundle.Api.Entity.App.V1.AbstractProduct.ProductItem;

export default function getProductAttribute(attributeTypeName: string, product: ProductItem) {
  return product.attributes.find((attribute) => attribute.typeName === attributeTypeName);
}
